import { registryComponent } from '@boost-sd/components-registry/registry';
import { InnerHTMLRenderer } from '@components/InnerHTMLRenderer';

export type IntegrationProductQuickViewProps = {
  template?: string;
};

const IntegrationProductQuickView = ({ template }: IntegrationProductQuickViewProps) => {
  if (!template) return null;

  return <InnerHTMLRenderer onClick={(e) => e.preventDefault()} html={template} />;
};

export default registryComponent('IntegrationProductQuickView', IntegrationProductQuickView);
